module.exports = __webpack_public_path__ + "static/media/low_high.6eb9aedd.svg";